__turbopack_context__.v({
  "hugeTitle": "SectionTitle-module-scss-module__h9CpdG__hugeTitle",
  "root": "SectionTitle-module-scss-module__h9CpdG__root",
  "smallTitle": "SectionTitle-module-scss-module__h9CpdG__smallTitle",
});
